import React from 'react';
import { Flex, Box, AspectRatio } from '@chakra-ui/react';
import Title from '@components/atoms/Title';
import HeaderFont from '@components/atoms/HeaderFont';
import RichText from '@components/atoms/RichText';
import Media from '@components/atoms/Media';
import Link from '@components/atoms/Link';
import { dataLayerClick } from '@helpers/dataLayerPush';

const bgColours = [`#ECD6F5`, `#5F249F`, `#15B2D8`];

const HeroPanelCard = ({ data, index = 0 }) => {
  return (
    <Flex
      key={data.id}
      bg={bgColours[index]}
      pos="relative"
      flexDirection="column"
      flex="1 1 0px"
      flexBasis="0">
      <Title
        m="3.5rem 2rem"
        pos="relative"
        zIndex="1"
        transform="rotate(-5deg)"
        textTransform="uppercase"
        lineHeight="2.25rem"
        fontWeight="900"
        fontSize={{ base: `6xl`, md: `7xl` }}
        fontStyle="italic"
        color={index > 0 ? `white` : `purple.600`}>
        <HeaderFont>{data.title}</HeaderFont>
      </Title>
      <Box width="100%" pos="relative" top="-7.5rem" left="0" zIndex="0">
        <Media media={data.image} width="100%" height="auto" />
      </Box>
      <Box
        mt="-5rem"
        p={{ base: `0 2rem`, sm: `0 8rem 0 2rem` }}
        pos="relative"
        fontSize="sm"
        color={index % 2 === 0 ? `#1A202C` : `#FFFFFF`}>
        <RichText data={data.content} />
      </Box>
      <Box
        mt="auto"
        p={{ base: `0 2rem 2.5rem`, sm: `0 8rem 2.5rem 2rem` }}
        fontSize="sm"
        color={index % 2 === 0 ? `#1A202C` : `#FFFFFF`}>
        <Link
          href={data.linkURL}
          bg="white"
          textTransform="uppercase"
          variant="whiteButton"
          mt="auto"
          fontSize="md"
          onClick={() => {
            dataLayerClick({
              event: `cta_click`,
              clickText: data.linkTitle,
              clickUrl: data.linkURL
            });
          }}>
          <HeaderFont>{data.linkTitle}</HeaderFont>
        </Link>
      </Box>
    </Flex>
  );
};

export default HeroPanelCard;
